<template>
  <router-view />
</template>

<script>
// import axios from 'axios';
export default {
  name: 'App',
  components: {
  },
  data() {
      return {
          breadCrumbs: [],
      }
  },
  created(){
    /*util.setLocalStorage('userInfo','')
    if(!util.getLocalStorage('TOKEN')||!util.getLocalStorage('userInfo')){
      localStorage.clear()
      this.$router.push('login');
    }*/
  },
}
</script>

<style>
</style>
